import {
	SET_CURRENT_USER,
	MONITOR_USER_SUCCESS,
	ADD_NEW_USER,
	UPDATE_USER,
	LOGOUT_USER,
	SET_LOGGED_IN,
	GET_USERS_SUCCESS,
	GET_USER_NOTIFICATIONS_SUCCESS,
	SET_CURRENT_USER_VIEW,
} from "../actionTypes";
const defaultState = {
	userDetails: {
		displayName: "",
		email: "",
		avatar: "",
		uid: "",
		phoneNumber: "",
		fname: "",
		lname: "",
		isAdmin: false,
		isAnonymous: true,
		emailVerified: false,
		customer_id: "",
		setup_secret: "",
		payments: {},
		payment_methods: {},
	},
	loggedIn: false,
	users: {},
	current: "",
};

const user = (state = defaultState, action) => {
	const { type, payload } = action;
	switch (type) {
		case ADD_NEW_USER:
			//console.log(payload);
			return state;
		case UPDATE_USER:
			return state;
		case SET_CURRENT_USER:
			// console.log("set Current");
			return {
				...state,
				userDetails: payload,
				loggedIn: true,
			};
		case SET_CURRENT_USER_VIEW:
			return {
				...state,
				current: payload,
			};
		case MONITOR_USER_SUCCESS:
			return { ...state, userDetails: { ...payload } };
		case LOGOUT_USER:
			return {
				...defaultState,
			};
		case SET_LOGGED_IN:
			return {
				...state,
				loggedIn: payload,
			};

		case GET_USER_NOTIFICATIONS_SUCCESS:
			return {
				...state,
				notifications: payload,
			};
		case GET_USERS_SUCCESS:
			//console.log(payload);
			return {
				...state,
				users: payload,
			};
		default:
			return state;
	}
};

export default user;
